import SeminarDetails from './SeminarDetails.container';

export default SeminarDetails;
